import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { initStoreShippingUnsubscribesAction } from 'reducks/storeShipping/actions'

const unsubscribeStoreShippings = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const unsubscribes = getState().storeShipping.unsubscribes
    unsubscribes.map((unsubscribe: () => void) => unsubscribe())
    dispatch(initStoreShippingUnsubscribesAction())
  }
}

export default unsubscribeStoreShippings
